var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results-empty"},[_c('div',{staticClass:"results-empty-content"},[_c('div',{staticClass:"results-empty-illustration"},[_c('img',{attrs:{"src":require("../../assets/images/empty.png"),"alt":"暂无匹配产品"}})]),_c('div',{staticClass:"results-empty-title"},[_vm._v("暂无匹配产品")])])])
}]

export { render, staticRenderFns }